// extracted by mini-css-extract-plugin
export var card = "styles-module--card--3xH8G";
export var card_inner = "styles-module--card_inner--lXm5B";
export var card_icon = "styles-module--card_icon--rmmKT";
export var card_title = "styles-module--card_title--16uDp";